// import { React, useMemo, useEffect, useState } from 'react';
// import { TextField, Paper, Button, Box, Typography } from '@mui/material';
// import SimpleMDE from 'react-simplemde-editor';
// import { useNavigate, useParams } from 'react-router-dom'
// import { useSelector } from 'react-redux';
// import axiosBase from '../../axios';
// import { FormNews } from './FormNews';

// import HeaderMain from '../../components/headerMain/HeaderMain';
// import 'easymde/dist/easymde.min.css';
// import './AddNewsPage.css'
// import { useNewsForm } from './useNewsForm';

// import ImageUploaderMany from '../../components/upload/ImageUploaderMany/ImageUploaderMany';
// import ImageGalleryWithDeletion from '../../components/upload/imageGalleryWithDeletion/ImageGalleryWithDeletion';

// const MAX_NEWS_IMAGES = 3;

// export const AddNewsPage = () => {
//   const { //данные формы
//     text, setText,
//     title, setTitle,
//     linkProgramm, setLinkProgramm,
//     programName, setProgramName,
//     handleProgramNameChange,
//     linkNews, setLinkNews,
//     handleLinkNews,
//     dateNews,
//     handleDateChange,
//     handleLinkProgrammChange,
//     handelNameNews,
//     handelChangeTextNews,
//   } = useNewsForm();

//   // Состояние для хранения массива ссылок на изображения
//   const [arrLinkImg, setArrLinkImg] = useState([]);

//   const isAuth = Boolean(useSelector(state => state.auth.data));
//   const navigate = useNavigate(); 
//   const { id } = useParams(); 
//   const isEditingNews = Boolean(id);
//   const typesProgramStore = useSelector(state => state.valueFilters.type);

//   const options = useMemo(
//     () => ({
//       spellChecker: false,
//       maxHeight: '350px',
//       autofocus: true,
//       placeholder: 'Введите текст статьи',
//       status: false,
//       autosave: {
//         enabled: true,
//         delay: 1000,
//       },
//     }),
//     [],
//   );

//   if(!window.localStorage.getItem('token') && !isAuth) {
//     navigate("/");
//     return null;
//   }

//   const onSubmit = async () => {
//     try {
//       const dateNewsFormat = dateNews;
      
//       const allDataNews = {
//         title,
//         imagesUrls: arrLinkImg, // массив ссылок на изображения
//         imageUrl: arrLinkImg[0] || '', // первое изображение для обратной совместимости
//         text,
//         programName,
//         typesProgramStore,
//         dateNewsFormat,
//         linkProgramm,
//         linkNews,
//       }
      
//       console.log("📤 Отправляем данные на сервер:", allDataNews);
//       console.log("📸 Количество изображений:", arrLinkImg.length);
      
//       const { data } = isEditingNews 
//         ? await axiosBase.patch(`/news/${id}`, allDataNews) 
//         : await axiosBase.post('/news', allDataNews) 

//       navigate("/news");
//     } catch (err){
//       console.warn(err); 
//       alert('Проблема с публикацией статьи', err); 
//     }
//   }

//   useEffect(() => {
//     if(isEditingNews) {
//       axiosBase.get(`/news/${id}`).then(({data}) => {
//         setTitle(data.title);
//         setText(data.text);
//         // Загружаем существующие изображения
//         if (data.imagesUrls && Array.isArray(data.imagesUrls) && data.imagesUrls.length > 0) {
//           setArrLinkImg(data.imagesUrls);
//         } else if (data.imageUrl) {
//           // Для обратной совместимости со старыми новостями
//           setArrLinkImg([data.imageUrl]);
//         }
//         setProgramName(data.programName);
//         setLinkProgramm(data.linkProgramm);
//         setLinkNews(data.linkNews);   
//       }).catch(err => {
//         console.warn(err);
//         alert('Ошибка получения статьи');
//       })   
//     }
//   }, [id]);

//   return (
//     <>
//       <HeaderMain/>
//       <Paper style={{ padding: 30, marginLeft: 100, marginRight: 100, marginTop: 30 }}>
//         <FormNews 
//           dateNews = {dateNews}
//           handleDateChange = {handleDateChange} 
//           programName = {programName}
//           handleProgramNameChange = {handleProgramNameChange}
//           linkProgramm = {linkProgramm} 
//           handleLinkProgrammChange = {handleLinkProgrammChange}
//           linkNews = {linkNews}
//           handleLinkNews = {handleLinkNews}
//         />

//         <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
//           Загрузите изображения для новости (до {MAX_NEWS_IMAGES} шт.):
//         </Typography>

//         <ImageUploaderMany 
//           url={'uploads_news_image'} 
//           folder={'newsImage'} 
//           setArrLinkImg={setArrLinkImg} 
//           maxNumImage={MAX_NEWS_IMAGES} 
//           arrLinkImg={arrLinkImg}
//         />

//         {/* Отображение загруженных изображений с возможностью удаления */}
//         {arrLinkImg.length > 0 && (
//           <>
//             <Typography variant="subtitle1" gutterBottom sx={{ mt: 2 }}>
//               Загруженные изображения ({arrLinkImg.length}/{MAX_NEWS_IMAGES}):
//             </Typography>
//             <ImageGalleryWithDeletion 
//               imageUrls={arrLinkImg} 
//               setArrLinkImg={setArrLinkImg}
//             />
//           </>
//         )}
        
//         <br />
//         <br />
        
//         <Box>
//           <TextField
//             id="hyperlink"
//             label="Введите заголовок статьи"
//             value={title}
//             onChange={handelNameNews}
//             fullWidth
//             variant="standard"
//             margin="normal"
//           />
//         </Box>

//         <SimpleMDE className="editor" value={text} onChange={handelChangeTextNews} options={options} />
        
//         <div className="buttons">
//           <Button 
//             onClick={() => dateNews ? onSubmit() : alert("Введите дату события")}           
//             size="large" 
//             variant="contained"
//           >
//             {isEditingNews ? "Сохранить" : "Опубликовать"}
//           </Button>
//           <a href="/">
//             <Button size="large">Отмена</Button>
//           </a>
//         </div>
//       </Paper>
//     </>
//   );
// };


import { React, useEffect, useState, useCallback } from 'react';
import { TextField, Paper, Button, Box, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import axiosBase from '../../axios';
import { FormNews } from './FormNews';

import { useNewsForm } from './useNewsForm';

import HeaderMain from '../../components/headerMain/HeaderMain';

// Импорты для редактора
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import ImageUploaderMany from '../../components/upload/ImageUploaderMany/ImageUploaderMany';
import ImageGalleryWithDeletion from '../../components/upload/imageGalleryWithDeletion/ImageGalleryWithDeletion';

const MAX_NEWS_IMAGES = 3;

// Функция для подсчета символов
const countTextChars = (html) => {
    if (!html) return 0;
    const textWithoutTags = html.replace(/<[^>]*>/g, '');
    return textWithoutTags.length;
};

// Функция очистки HTML от лишних атрибутов
const cleanHtml = (html) => {
    if (!html) return '';
    let cleaned = html.replace(/data-offset-key="[^"]*"/g, '');
    cleaned = cleaned.replace(/data-block="true"/g, '');
    cleaned = cleaned.replace(/data-editor="[^"]*"/g, '');
    cleaned = cleaned.replace(/\s+/g, ' ').trim();
    return cleaned;
};

const allEmojis = [
    '😊', '🙂', '😄', '😃', '😁', '🤔', '🧠', '💡', '🧐', '📚', '🎓',
    '✅', '⭐', '👍', '👏', '🔥', '🏆', '🏅', '🤝', '🙏', '❓', 'ℹ️', '⚠️',
    '👀', '🔍', '💻', '✍️', '📖', '📅', '⏰', '📧', '💬', '📢',
    '🎉', '💫', '🤖', '📰', '📝'
];

export const AddNewsPage = () => {
  const [editorState, setEditorState] = useState(() => EditorState.createEmpty());
  const [charCount, setCharCount] = useState(0);
  const [arrLinkImg, setArrLinkImg] = useState([]);
  const [isInitialized, setIsInitialized] = useState(false);
  
  const {
    text, setText,
    title, setTitle,
    linkProgramm, setLinkProgramm,
    programName, setProgramName,
    handleProgramNameChange,
    linkNews, setLinkNews,
    handleLinkNews,
    dateNews,
    handleDateChange,
    handleLinkProgrammChange,
    handelNameNews,
  } = useNewsForm();

  const isAuth = Boolean(useSelector(state => state.auth.data));
  const navigate = useNavigate();
  const { id } = useParams();
  const isEditingNews = Boolean(id);
  const typesProgramStore = useSelector(state => state.valueFilters.type);

  if (!window.localStorage.getItem('token') && !isAuth) {
    navigate("/");
    return null;
  }

  // Загрузка данных при редактировании
  useEffect(() => {
    if (isEditingNews && id && !isInitialized) {
      axiosBase.get(`/news/${id}`).then(({ data }) => {
        console.log("Загружена новость:", data);
        
        setTitle(data.title || '');
        setText(data.text || '');
        setProgramName(data.programName || '');
        setLinkProgramm(data.linkProgramm || '');
        setLinkNews(data.linkNews || '');
        
        // Загружаем изображения
        if (data.imagesUrls && Array.isArray(data.imagesUrls) && data.imagesUrls.length > 0) {
          setArrLinkImg(data.imagesUrls);
        } else if (data.imageUrl && data.imageUrl !== '') {
          setArrLinkImg([data.imageUrl]);
        }
        
        // Инициализируем редактор из HTML
        if (data.text && data.text !== '<p></p>' && data.text !== '') {
          try {
            const cleanedHtml = cleanHtml(data.text);
            const contentBlock = htmlToDraft(cleanedHtml);
            if (contentBlock && contentBlock.contentBlocks && contentBlock.contentBlocks.length > 0) {
              const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
              const newState = EditorState.createWithContent(contentState);
              setEditorState(newState);
              const count = countTextChars(cleanedHtml);
              setCharCount(count);
            }
          } catch (error) {
            console.error('Error initializing editor:', error);
            // Если ошибка, создаем пустой редактор
            setEditorState(EditorState.createEmpty());
          }
        }
        
        setIsInitialized(true);
      }).catch(err => {
        console.warn(err);
        alert('Ошибка получения статьи');
      });
    }
  }, [id, isEditingNews, isInitialized, setTitle, setText, setProgramName, setLinkProgramm, setLinkNews]);

  // Обновление счетчика и text при изменении editorState
  useEffect(() => {
    if (editorState) {
      const html = draftToHtml(convertToRaw(editorState.getCurrentContent()));
      const cleanHtmlString = cleanHtml(html);
      const charLength = countTextChars(cleanHtmlString);
      setCharCount(charLength);
      setText(cleanHtmlString);
    }
  }, [editorState, setText]);

  const handleEditorChange = (state) => {
    try {
      setEditorState(state);
    } catch (error) {
      console.error('Error in handleEditorChange:', error);
    }
  };

  const onSubmit = async () => {
    try {
      if (!dateNews) {
        alert("Введите дату события");
        return;
      }
      
      if (!title || title.trim() === '') {
        alert("Введите заголовок статьи");
        return;
      }
      
      if (!text || text === '<p></p>' || text.trim() === '' || text === '<p><br></p>') {
        alert("Введите текст статьи");
        return;
      }
      
      const allDataNews = {
        title,
        imagesUrls: arrLinkImg,
        imageUrl: arrLinkImg[0] || '',
        text: text,
        programName: programName || '',
        typesProgramStore,
        dateNewsFormat: dateNews,
        linkProgramm: linkProgramm || '',
        linkNews: linkNews || '',
      };
      
      console.log("📤 Отправляем данные:", allDataNews);
      
      let response;
      if (isEditingNews) {
        response = await axiosBase.patch(`/news/${id}`, allDataNews);
      } else {
        response = await axiosBase.post('/news', allDataNews);
      }
      
      console.log("✅ Ответ сервера:", response.data);
      navigate("/news");
    } catch (err) {
      console.warn(err);
      alert('Ошибка: ' + (err.response?.data?.message || err.message));
    }
  };

  return (
    <>
      <HeaderMain />
      <Paper style={{ padding: 30, marginLeft: 100, marginRight: 100, marginTop: 30 }}>
        <FormNews 
          dateNews={dateNews}
          handleDateChange={handleDateChange} 
          programName={programName}
          handleProgramNameChange={handleProgramNameChange}
          linkProgramm={linkProgramm} 
          handleLinkProgrammChange={handleLinkProgrammChange}
          linkNews={linkNews}
          handleLinkNews={handleLinkNews}
        />

        <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
          Загрузите изображения для новости (до {MAX_NEWS_IMAGES} шт.):
        </Typography>

        <ImageUploaderMany 
          url={'uploads_news_image'} 
          folder={'newsImage'} 
          setArrLinkImg={setArrLinkImg} 
          maxNumImage={MAX_NEWS_IMAGES} 
          arrLinkImg={arrLinkImg}
        />

        {arrLinkImg.length > 0 && (
          <>
            <Typography variant="subtitle1" gutterBottom sx={{ mt: 2 }}>
              Загруженные изображения ({arrLinkImg.length}/{MAX_NEWS_IMAGES}):
            </Typography>
            <ImageGalleryWithDeletion 
              imageUrls={arrLinkImg} 
              setArrLinkImg={setArrLinkImg}
            />
          </>
        )}
        
        <br />
        <br />
        
        <Box>
          <TextField
            label="Введите заголовок статьи"
            value={title}
            onChange={handelNameNews}
            fullWidth
            variant="standard"
            margin="normal"
          />
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1, mt: 2 }}>
          <Typography variant="body2" color="text.secondary">
            {charCount} символов
          </Typography>
        </Box>

        <Box sx={{ 
          border: '1px solid #ddd', 
          borderRadius: 1, 
          p: 1,
          '& .rdw-editor-main': {
            minHeight: '350px',
            maxHeight: '500px',
            overflow: 'auto'
          }
        }}>
          <Editor
            editorState={editorState}
            onEditorStateChange={handleEditorChange}
            toolbar={{
              options: ['inline', 'blockType', 'list', 'link', 'emoji', 'history'],
              emoji: { emojis: allEmojis },
              inline: { options: ['bold', 'italic', 'underline'] },
              blockType: { options: ['Normal', 'H1', 'H2', 'H3'] },
              list: { options: ['unordered', 'ordered'] },
            }}
            placeholder="Введите текст статьи..."
            editorStyle={{ minHeight: '350px' }}
            stripPastedStyles={true}
          />
        </Box>

        <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
          💡 Подсказка: для вставки смайликов нажмите на иконку 😊 в панели инструментов
        </Typography>

        <div className="buttons" style={{ marginTop: 20, display: 'flex', gap: 10 }}>
          <Button onClick={onSubmit} size="large" variant="contained">
            {isEditingNews ? "Сохранить" : "Опубликовать"}
          </Button>
          <a href="/news">
            <Button size="large">Отмена</Button>
          </a>
        </div>
      </Paper>
    </>
  );
};